import Legislator from './Legislator';
import LegislatorType from './LegislatorType';
import Representative from './Representative';
import Senator from './Senator';

export * from './Legislator';
export * from './Representative';
export * from './Senator';
export { getLegislatorClassForTerm } from './LegislatorClasses';
export { LegislatorType, Legislator, Representative, Senator };
